/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { MedicalCondition } from '../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    medicalCondition: MedicalCondition
}

const CreatedInCell: FC<Props> = ({ medicalCondition }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {medicalCondition.createdAt ? formatDateTime(medicalCondition.createdAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.createdAt ? franchise.createdAt.toString() : 'N/A'}</span> */}
    </div>
)

export { CreatedInCell }
